import { useQuery } from "@tanstack/react-query"
import { recruitmentService } from "@/modules/recruitment/infrastructure/recruitment-service"

export interface HiredCandidateDto {
  applicationId: string
  candidateId: string
  candidateName: string
  email: string
  phone?: string
  jobId: string
  jobTitle: string
  department: string
  hiredDate: string
  matchScore: number
  onboardingStarted: boolean
}

export function useHiredCandidates(hiredAfter?: string, hiredBefore?: string) {
  return useQuery({
    queryKey: ["hiredCandidates", hiredAfter, hiredBefore],
    queryFn: () =>
      recruitmentService.getHiredCandidates(hiredAfter, hiredBefore),
  })
}
